import { GetWpAiConfigResponse } from "../../models/aiassist"
import { queryApi } from "../api"
import { wpAiConfigTag } from "../tags"

export const wpAiConfigApi = queryApi.injectEndpoints({
    endpoints(build) {
        return {
            getWpAiConfig: build.query<GetWpAiConfigResponse, void>({
                query: () => ({
                    url: "/wp-ai-config"
                }),
                providesTags: [wpAiConfigTag]
            })
        }
    }
})

export const { useGetWpAiConfigQuery } = wpAiConfigApi
